/**
 * Panel — gemeinsamer Inhalts-Baustein (aus den Design-Prototypen).
 *
 * Eine flache Karte ohne Schlagschatten (`Card elevation={0}`) mit der im
 * Prototyp festgelegten Polsterung/Abstand (`p:2, mb:2`). Rein präsentational:
 * kein Zustand, keine Logik. Zusätzliche `sx`-Werte werden gemerged, weitere
 * `CardProps` (z. B. `component`, `aria-labelledby`) durchgereicht.
 */

import Card, { type CardProps } from "@mui/material/Card";
import type { SxProps, Theme } from "@mui/material/styles";
import type { ReactNode } from "react";

export default function Panel({
  children,
  sx,
  ...rest
}: { children: ReactNode; sx?: SxProps<Theme> } & Omit<CardProps, "elevation">) {
  return (
    <Card elevation={0} sx={{ p: 2, mb: 2, ...sx }} {...rest}>
      {children}
    </Card>
  );
}
